export { default as LegalInfo } from "./components/Main";
export type { LegalInfoProps } from "./components/Main";
export { default as LegalInfoPreview } from "./components/Preview";
